import { Component, OnDestroy } from "@angular/core";
import { Data, Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { ModalController, NavController, IonicModule } from "@ionic/angular";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { CommonVariable } from "src/app/app.constants";
import { AccountRepositoryService } from "../account-repository.service";
import { Subject, take, takeUntil } from "rxjs";
import { CloseAccountComponent } from "src/app/components/close-account/close-account.component";
import { LoadingService } from "@core/loading.service";
import { MatDialog } from "@angular/material/dialog";
import { PermanentlyCloseComponent } from "src/app/components/permanently-close-popup/permanently-close-popup.component";
import { SafeHtmlPipe } from "../../../pipe/safehtmlpipe";

@Component({
    templateUrl: "./close-confirmation.component.html",
    styleUrls: ["./close-confirmation.component.scss"],
    standalone: true,
    imports: [
        IonicModule,
        SafeHtmlPipe,
        TranslatePipe,
    ],
})
export class CloseConfirmationComponent implements OnDestroy {
  syndicateLoaded: boolean;
  jackpotLoaded: boolean;

  setActive = true;
  setActiveTrigger = true;
  translatedToastMsg: Data;
  selectedLanguage = "en";
  public preferredCurrency: string;
  public currencySymbol: string = CommonVariable.defaultCurrencySymbol;
  public spinnerAnimation: boolean;
  public progressBar: number;
  public sub: Data;
  public proceed = true;
  errorAlert = false;
  acceptanceCheckbox = false;
  private unsubscribe$ = new Subject<void>();

  constructor(
    public translate: TranslateService,
    private authService: AuthService,
    private navController: NavController,
    private accountRepository: AccountRepositoryService,
    private modalController: ModalController,
    private loadingService: LoadingService,
    private matDialog: MatDialog,
    private router: Router,
  ) {
    this.preferredCurrency = CommonVariable.preferredCurrency;
    this.currencySymbol = CommonVariable.defaultCurrencySymbol;
    this.authService.selectedlanguage$.pipe(takeUntil(this.unsubscribe$)).subscribe(
      (l) => {
        this.selectedLanguage = l;
        translate.use(l ? l : "en");
      },
      (err) => {
        return err;
      }
    );
  }
  ngOnDestroy(): void {
    this.unsubscribe$?.next();
    this.unsubscribe$?.complete();
  }

  goBack() {
    this.navController.back();
  }

  goToGetHelpPage() {
    this.router.navigateByUrl("account/helpSupport?bot_flow=hi");
  }

  goToDeleteAccountPage() {
    this.router.navigateByUrl("delete-your-account");
  }

  onCheck(event) {
    const value = event?.detail?.checked;
    this.acceptanceCheckbox = value;
  }

  onClose() {
    if (!this.acceptanceCheckbox) {
      this.errorAlert = true;
      return;
    }
    this.errorAlert = false;
    this.accountRepository
      .getUserPreferences()
      .pipe(take(1))
      .subscribe((value) => {
        this.closeMyAccount(value?.content[1]?.text);
      });
  }

  closeMyAccount(action) {
    const confirmationDialog = this.matDialog.open(CloseAccountComponent, {
      panelClass: "close-account-dialog-size",
      backdropClass: "cashout-back-drop-color",
    });

    confirmationDialog.afterClosed().subscribe(
      async (dialogResponse: boolean) => {
        if (dialogResponse) {
          this.closeAccount(action, "close_my_account");
        }
      },
      (err) => {
        return err;
      }
    );
  }

  private closeAccount(action: string, moduleName: string): void {
    this.loadingService.present();
    this.accountRepository.insertUserGDPR(action, moduleName).subscribe(
      (gdprRes) => {
        if (gdprRes?.status === "rejected") {
          this.loadingService.dismiss();
          this.authService
            .getConstantsMsg(gdprRes?.error_code)
            .then((translatedMsg) => {
              const defaultMsg = {
                message: {
                  line_1: "Something went wrong!",
                  line_2: "",
                },
                style: {
                  icon: "tick circle error.svg",
                  type: "Error",
                },
              };
              this.authService.showToastMessage(translatedMsg, defaultMsg);
            })
            .catch((error) => {
              return error;
            });
          return;
        }
        if (gdprRes && gdprRes?.response?.status?.toLowerCase() === "success") {
          try {
            this.loadingService.dismiss().catch((err) => {
              return err;
            });
            const confirmationDialog = this.matDialog.open(PermanentlyCloseComponent, {
              panelClass: "remove-confirmation-popup",
              backdropClass: "back-drop-popup",
              enterAnimationDuration: "500ms",
              exitAnimationDuration: "500ms",
              data: "closed",
            });

            confirmationDialog.afterClosed().subscribe(
              () => {
                // This method has been used to redirect the user logout
                this.authService
                  .logout()
                  .then(() => {
                    // This method has been used to redirect the user after logout on the welcome page
                    this.router.navigateByUrl("/welcome");
                  })
                  .catch((error) => {
                    return error;
                  });
                this.modalController.dismiss(true).catch((err) => {
                  return err;
                });
              },
              (err) => {
                return err;
              }
            );
          } catch (error) {
            return error;
          }
        } else {
          this.loadingService.dismiss().catch((err) => {
            return err;
          });
          this.authService
            .getConstantsMsg("1014")
            .then((translatedMsg) => {
              const defaultMsg = {
                message: {
                  line_1: "Something went wrong",
                  line_2: "",
                },
                style: {
                  icon: "tick circle error.svg",
                  type: "Error",
                },
              };
              this.authService.showToastMessage(translatedMsg, defaultMsg);
            })
            .catch((error) => {
              return error;
            });
        }
      },
      () => {
        this.loadingService.dismiss().catch((err) => {
          return err;
        });
        /*  const msg = this.translatedToastMsg?.["1014"]?.[this.selectedLanguage];
         this.authService.showToast(msg ? msg : "Something went wrong", "Error", ""); */
        this.authService
          .getConstantsMsg("1014")
          .then((translatedMsg) => {
            const defaultMsg = {
              message: {
                line_1: "Something went wrong",
                line_2: "",
              },
              style: {
                icon: "tick circle error.svg",
                type: "Error",
              },
            };
            this.authService.showToastMessage(translatedMsg, defaultMsg);
          })
          .catch((error) => {
            return error;
          });
      }
    );
  }
}
